import { SvgIcon } from '@material-ui/core';
import React from 'react';

export function MyEduzzIcon() {
  return (
    <SvgIcon fontSize='large'>
      <svg xmlns='http://www.w3.org/2000/svg' id='Camada_2' viewBox='0 0 45 30'>
        <g id='Camada_1-2'>
          <g>
            <rect fill='#17296e' x='18.21' y='1.94' width='13.05' height='28.19' />
            <circle fill='#ffbe00' cx='18.21' cy='16.03' r='16.03' />
            <path
              fill='#0d2772'
              d='M7.39,27.42h9.77c1.56,0,2.82-1.26,2.82-2.82s-1.26-2.84-2.82-2.84H4.03s-.02-.05-.03-.08c-.3-.88-.53-1.79-.7-2.74h7.41c1.56,0,2.82-1.26,2.82-2.82s-1.26-2.82-2.82-2.82H3.3c.17-.94,.4-1.87,.71-2.74,0-.03,.02-.05,.03-.08h13.13c1.56,0,2.82-1.26,2.82-2.82s-1.26-2.82-2.82-2.82H7.38c1-1.11,2.15-2.09,3.41-2.9H0V30.13H10.53c-1.15-.78-2.21-1.68-3.14-2.71Z'
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
